export const addHttpToUrl = (url: string | null | undefined): string => {
  if (!url) {
    return "";
  }

  if (url.includes("http://") || url.includes("https://")) {
    return url;
  }

  return `https://${url}`;
};
